import { SearchResourceType } from "@app/core/model/search/search-resource-type";
import { SearchResourceDictionaryService } from "@app/core/services/resource-dictionary/search-resource-dictionary.service";
import { DataTableUtilities } from "@app/core/utilities/data-table-utilities";
import { BsshDatePipe } from "@app/core/utilities/pipes/bssh-date.pipe";
import { BytesPipe } from "@app/core/utilities/pipes/bytes.pipe";
import { RadLinkRendererComponent } from "@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component";
import { ProjectSearchColumnFields, ProjectSearchGridOptionsFormatter } from "@app/search/gridOptions/project-search-grid-options-formatter"
import { OverrideColumnDefinition, OverrideColumnParameters } from "@app/search/gridOptions/search-grid-options-formatter";

export class ProjectChooserGridOptionsFormatter extends ProjectSearchGridOptionsFormatter {
    constructor(
        public resourceDictionaryService: SearchResourceDictionaryService,
        public bytePipe: BytesPipe,
        public bsshDatePipe: BsshDatePipe
    ) {
        super(resourceDictionaryService, bytePipe, bsshDatePipe);
    }

    protected getOverrideColumnParameters(): OverrideColumnParameters<ProjectSearchColumnFields> {
        const inclusiveColumns: ProjectSearchColumnFields[] = [
            ProjectSearchColumnFields.Name,
            ProjectSearchColumnFields.Owner,
            ProjectSearchColumnFields.DateUpdated
          ];

        const overrideColumnDefinitions: OverrideColumnDefinition<ProjectSearchColumnFields>[] = [
            {
                headerName: 'Project',
                field: 'Project.Name',
                showAlways: true,
                cellRendererFramework: RadLinkRendererComponent,
                cellRendererParams: (params: any) => {
                    if(params.data) {
                        const tooltipText = !this.isRowSelectable(params.node) ? this.getUnselectableRowMessage(params.node) : null;
                        const cellRendererParams = DataTableUtilities.getRadLinkParams(
                            params.data.Project.Name,
                            this.resourceConfig.uiHrefAccessor(params.data),
                            tooltipText,
                            null,
                            60
                        );
                      return cellRendererParams;
                    } else {
                      return {};
                    }
                },
                colId: ProjectSearchColumnFields.Name,
                filterActive: false,
                sortable: false,
                filter: 'customFilter',
                flex: 4.5
            }
        ];

        return {
            inclusiveColumns,
            overrideColumnDefinitions
        };
    }
}